import * as Yup from 'yup'
import { VinculoMode } from '../../../../vinculos-especialidade-list/components/modal/validation/epecialidadeVinculoSchema'
import { TFunction } from '_metronic/i18n/Metronici18n'
import { createValidation } from '_metronic/helpers'

export const tiposAtendimentoSchema = (t: TFunction) => {
  const v = createValidation(t)

  return Yup.object({
    tipoAtendimento: Yup.object().required('Tipo de atendimento é obrigatório'),

    mode: Yup.mixed<VinculoMode>()
      .oneOf(Object.values(VinculoMode), 'Selecione o tipo de vínculo')
      .required('Selecione o tipo de vínculo'),

    empresas: Yup.array().when('mode', {
      is: VinculoMode.Empresa,
      then: (schema) =>
        schema.min(1, v.requiredField('empresa', 'array')).required('Instituição é obrigatória'),
      otherwise: (schema) => schema.notRequired(),
    }),

    empresa: Yup.object().when('mode', {
      is: VinculoMode.Unidade,
      then: (schema) => schema.required(v.requiredField('empresa', 'select')),
      otherwise: (schema) => schema.notRequired(),
    }),

    unidades: Yup.array().when('mode', {
      is: VinculoMode.Unidade,
      then: (schema) =>
        schema.min(1, v.requiredField('unidade', 'array')).required('Unidade é obrigatória'),
      otherwise: (schema) => schema.notRequired(),
    }),
  })
}
